module.exports = __webpack_public_path__ + "static_1764244025768/img/headder.529e00a1.jpg";